var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFuelTypePetrol24 = function SvgFuelTypePetrol24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.701 10.553a7.462 7.462 0 0 1 .587 7.385 7.171 7.171 0 0 1-2.457 2.88 6.838 6.838 0 0 1-3.535 1.175 6.807 6.807 0 0 1-3.618-.861 7.11 7.11 0 0 1-2.684-2.655A7.435 7.435 0 0 1 5 14.774a7.438 7.438 0 0 1 .976-3.707l.545-.847L12.027 2l5.675 8.553Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFuelTypePetrol24;